"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UserDetailsGenerator = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _config = _interopRequireDefault(require("./config"));
var _styles = _interopRequireDefault(require("./styles"));
var _utils = _interopRequireDefault(require("../utils"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var CustomCheckbox = (0, _core.withStyles)({
  root: {
    color: '#375FAC',
    '&$checked': {
      color: '#375FAC'
    }
  },
  checked: {}
})(function (props) {
  return /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
    color: "default"
  }, props));
});

/**
 * Generate User Details component with the custom configuration
 * applied
 *
 * @param {object} [uiConfig]
 * @returns {object} { SearchBox }
 */
var UserDetailsGenerator = function UserDetailsGenerator() {
  var uiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.default;
  var functions = uiConfig.functions;
  var cn = functions && typeof functions.cn === 'function' ? functions.cn : _config.default.functions.cn;
  var UserDetails = function UserDetails(_ref) {
    var classes = _ref.classes,
      handleCheckbox = _ref.handleCheckbox,
      userInfo = _ref.userInfo,
      userRole = _ref.userRole;
    var _utils$default = _utils.default,
      capitalizeFirstLetter = _utils$default.capitalizeFirstLetter,
      getAuthenticatorName = _utils$default.getAuthenticatorName;
    var checkbox = null;
    var checkboxLabel = null;

    // Determine whether to create a checkbox
    if (handleCheckbox) {
      checkbox = /*#__PURE__*/_react.default.createElement("span", {
        className: classes.infoValue
      }, /*#__PURE__*/_react.default.createElement(CustomCheckbox, {
        checked: userRole === 'admin',
        onChange: handleCheckbox,
        color: "primary",
        inputProps: {
          'aria-label': 'secondary checkbox'
        }
      }));
      checkboxLabel = /*#__PURE__*/_react.default.createElement("span", {
        className: cn(classes.infoKey, classes.toggleAdmin)
      }, "ADMIN PERMISSIONS:");
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.userInfoHeader
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.firstInfoSection
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.infoKeyWrapper
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.userInfo
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: classes.infoKey
    }, "ACCOUNT\xA0TYPE: "), /*#__PURE__*/_react.default.createElement("span", {
      className: classes.infoKey
    }, "EMAIL\xA0ADDRESS: "), /*#__PURE__*/_react.default.createElement("span", {
      className: classes.infoKey
    }, "NAME: "))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.userInfo
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: classes.infoValue
    }, getAuthenticatorName(userInfo.IDP)), /*#__PURE__*/_react.default.createElement("span", {
      className: classes.infoValue
    }, userInfo.email), /*#__PURE__*/_react.default.createElement("span", {
      className: classes.infoValue
    }, capitalizeFirstLetter(userInfo.lastName), ", \xA0", capitalizeFirstLetter(userInfo.firstName))))), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.secondInfoSection
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.infoKeyWrapper
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.userInfo
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: classes.infoKey
    }, "ORGANIZATION: "), /*#__PURE__*/_react.default.createElement("span", {
      className: classes.infoKey
    }, "MEMBERSHIP\xA0STATUS: "), /*#__PURE__*/_react.default.createElement("span", {
      className: classes.infoKey
    }, "ROLE: "), checkboxLabel)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      component: "div",
      className: classes.userInfo
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: classes.infoValue
    }, capitalizeFirstLetter(userInfo.organization)), /*#__PURE__*/_react.default.createElement("span", {
      className: classes.infoValue
    }, userInfo.userStatus === '' ? 'N/A' : capitalizeFirstLetter(userInfo.userStatus)), /*#__PURE__*/_react.default.createElement("span", {
      className: classes.infoValue
    }, capitalizeFirstLetter(userInfo.role)), checkbox))));
  };
  return {
    // @ts-ignore
    // eslint-disable-next-line max-len
    UserDetails: (0, _core.withStyles)(_styles.default, {
      withTheme: true
    })(UserDetails)
  };
};
exports.UserDetailsGenerator = UserDetailsGenerator;
var _default = UserDetailsGenerator;
exports.default = _default;